import "./OptionContainer.scss";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { FCCWithClassName } from "types";

import { Subtract } from "@/assets/icons/icons";

interface Props {
  selected?: boolean;
  highlighted?: boolean;
  recommended?: boolean;
  precharged?: boolean;
  disabled?: boolean;
  voice?: boolean;
}

export const OptionContainer: FCCWithClassName<Props> = ({
  selected,
  children,
  recommended,
  precharged = false,
  highlighted,
  disabled = false,
  voice = false,
  className,
}) => {
  const { t } = useTranslation();

  const label =
    recommended && !precharged
      ? t("Onboarding.sections.rate-selection.recommended")
      : precharged
        ? t("Onboarding.sections.rate-selection.precharged")
        : null;

  return (
    <div
      className={clsx(
        className,
        "rate-selection-row",
        selected && "selected",
        highlighted && "highlighted",
        recommended && "recommended",
        disabled && !selected && "disabled",
        voice && "voice",
        precharged && "precharged",
      )}
    >
      {label && (
        <>
          <div className="flag-label">{label}</div>
          <div className="hint">
            <Subtract />
          </div>
        </>
      )}
      {children}
    </div>
  );
};
